import { jsx as _jsx } from "react/jsx-runtime";
import { setDefaultOptions } from 'date-fns';
import { enCA, frCA } from 'date-fns/locale';
import { createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';
// le format de date CA n'est pas défini correctement dans date-fns
const dateFormats = {
    full: 'EEEE d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'yyyy-MM-dd',
};
// Original source function. Import do not work
const buildFormatLongFn = (args) => {
    return (options = {}) => {
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
};
frCA.formatLong.date = buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full',
});
export * from 'date-fns';
const DateFnsContext = createContext({ locale: enCA });
export const useDateFnsLocale = () => {
    const context = useContext(DateFnsContext);
    if (!context) {
        throw new Error('useDateFnsLocale must be used within a DateFnsLocaleProvider');
    }
    return context;
};
export const DateFnsLocaleProvider = ({ children }) => {
    const { i18n: { resolvedLanguage }, } = useTranslation();
    const locale = resolvedLanguage === 'fr' ? frCA : enCA;
    setDefaultOptions({ locale });
    return _jsx(DateFnsContext.Provider, { value: { locale }, children: children });
};
